import React from 'react';
import { UserPagePermissions } from './components/UserPagePermissions';

interface UserPagePermission2Props {
  userId: number;
}

export const UserPagePermission2: React.FC<UserPagePermission2Props> = ({
  userId,
}) => {
  return <UserPagePermissions userId={userId} />;
};
